export default "__VITE_ASSET__DpGSYzpM__"